import { render, staticRenderFns } from "./Scoreddetails.vue?vue&type=template&id=1b4487f1"
import script from "./Scoreddetails.vue?vue&type=script&lang=js"
export * from "./Scoreddetails.vue?vue&type=script&lang=js"
import style0 from "./Scoreddetails.vue?vue&type=style&index=0&id=1b4487f1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports